// src/utils/customHttp.js
import axios from "axios";
import { API_BASE_URL } from "../config";

// Create a custom axios instance
const customHttp = axios.create({
	baseURL: API_BASE_URL || "http://localhost:5000/api", // base URL for the backend
	headers: {
		"Content-Type": "application/json",
		// You can dynamically add the token later
	},
});

console.log("Base API URL: ", API_BASE_URL);

// Intercept request to add authorization token dynamically
customHttp.interceptors.request.use(
    (config) => {
        // Retrieve token from local storage or any global state like context
        const token = "sQ99r3Sd6Q2C5YC1cGNGfaI5ce3efhoX"; // Assuming the token is stored in localStorage
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default customHttp;
